import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { EmptyStar, FilledStar } from "../svg/GeneralIcons";
import { Capitalize } from "../../utils";
import clsx from "clsx";

function BoxGames({ x, fromCategory, onRoute }) {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 3, delay: 0.4 }}
      className={clsx(
        fromCategory ? "" : "mx-4 mb-4",
        "rounded-2xl glassy grid mt-0  hover:scale-95",
      )}
      onClick={() => {
        if (onRoute) {
          onRoute();
        } else {
          if (x.id) {
            navigate(`/campaign_id/${x.id}`);
          } else {
            navigate(`/game-started?slug=${x.slug}`);
          }
        }
      }}
    >
      <div className="grid relative bg-white p-1 rounded-[10px]">
        <div className="">
          <img
            className="w-full object-cover rounded-[5px] h-[170px]"
            src={x?.image_url ?? "/image/car.png"}
            alt="banner"
            loading="lazy"
          />
        </div>
        <p className="text-black font-semibold text-left text-sm mt-2.5 line-clamp-1">
          {Capitalize(x.title ?? x.name)}
        </p>
        <div className="flex items-center gap-0.5 mb-1">
          <FilledStar />
          <FilledStar />
          <FilledStar />
          <FilledStar />
          <EmptyStar />
        </div>
      </div>
    </motion.div>
  );
}

export default BoxGames;
